import getScrollbarWidth from "qj/getScrollbarWidth";
getScrollbarWidth.setCSSvar();

import "js/Layout";
import "js/Search";
import "js/sectionObserver";
import "js/AccordionList";
import "js/ImageCarousel";

const html = document.querySelector("html");

//const loginform = document.querySelector(".upme-login");
// const loginform = document.querySelectorAll(
//   ".upme-login, .upme-reset-password"
// );
if (html?.classList.contains("loginpage")) {
  //if (loginform.length > 0) {
  var elements = document.querySelectorAll(
    ".upme-field input:not([type='button']"
  );
  elements.forEach((e) => {
    var label = e
      .closest(".upme-field")
      ?.querySelector("label")
      ?.textContent?.trim();
    e.setAttribute("placeholder", String(label));
  });

  // wrap stuff
  var links = document.querySelector(".upme-button");
  if (
    document.querySelectorAll(
      ".upme-login-forgot-link, .upme-login-register-link"
    ).length > 0
  ) {
    var newElm = document.createElement("div");
    newElm.classList.add("loginlinks");
    Array.prototype.forEach.call(
      links
        ?.closest(".upme-field-value")
        ?.querySelectorAll(
          ".upme-login-forgot-link, .upme-login-register-link "
        ),
      function (c) {
        newElm.appendChild(c);
      }
    );
    links?.closest(".upme-field-value")?.appendChild(newElm);
    links?.nextSibling?.nextSibling?.remove();
  }
}

// Filter search
if (document.getElementById("searchForm")) {
  var input = document.getElementById("leitarord");
  input?.addEventListener("blur", () => {
    var myForm = <HTMLFormElement>document.getElementById("searchForm");
    document.getElementById("searchForm")?.classList.add("updating");
    myForm.submit();
  });

  var select = document.querySelectorAll("#searchForm select");
  select.forEach((select) =>
    select.addEventListener("change", () => {
      var myForm = <HTMLFormElement>document.getElementById("searchForm");
      document.getElementById("searchForm")?.classList.add("updating");
      myForm.submit();
    })
  );
}

// if (html?.classList.contains("home")) {
//   console.log("yooyoyo");
//   var newElm = document.createElement("div");
//   newElm.classList.add("myGuy");
//   Array.prototype.forEach.call(
//     document.querySelectorAll(".home-news, .interesting"),
//     function (c) {
//       newElm.appendChild(c);
//     }
//   );
//   document.querySelector(".Layout__content")?.appendChild(newElm);
// }

// function wrap(el: any, wrapper: any) {
//   el.parentNode.insertBefore(wrapper, el);
//   wrapper.appendChild(el);
// }
// wrap(document.querySelector(".wrappthis"), document.createElement("div"));

// var el = document.querySelector(".wrappthis");
// var wrapper = document.createElement("div");
// el?.parentNode?.insertBefore(wrapper, el);
// wrapper.appendChild(el);

document.documentElement.classList.remove("beforejsinit", "loading");
